export default __webpack_public_path__ + "static/media/thinkai2.3fb80a79.jpg";